// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import LoadScript from 'vue-plugin-load-script';
import Auth from './store/auth';

Vue.use(LoadScript);

/**
 * Firebase  설정
 */
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyDqTCAFZyJjP_F4UnkVJ5pmWQyljVD43_U",
  authDomain: "kokoro-294123.firebaseapp.com",
  databaseURL: "https://kokoro-294123.firebaseio.com",
  projectId: "kokoro-294123",
  storageBucket: "kokoro-294123.appspot.com",
  messagingSenderId: "956950391804",
  appId: "1:956950391804:web:6890b41a778a1b7df96079",
  measurementId: "G-1KD9GX7YYE"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();


Vue.config.productionTip = false
const EventBus = new Vue();
window.auth = new Auth();
/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data:{
    authorised: false,
  },
  created() {
    const _self = this;
    this.$on("onLogonSuccss", function(auth){
      _self.authorised = auth;
    })
  }
})
window.app = vm



// WEBPACK FOOTER //
// ./src/main.js